import React, { useState } from 'react';
import moment from 'moment';
import RangeTimePicker from '../../../../../components/RangeTimePicker';
import {
  Container,
  RangeTimeRow,
  Subtitle,
  ContainerCheckboxWeek
} from './styles';
import { IDayAndTimeToReceive } from '../../../../../store/ducks/fabrication-contracts/types';
import { endTimeIsGreaterThanStartTime } from '../../constructionRegistrationFieldsValidations';
import { Button, Checkbox } from '@gerdau/hefesto';

const WeekDays = {
  '1': 'Segunda-feira',
  '2': 'Terça-feira',
  '3': 'Quarta-feira',
  '4': 'Quinta',
  '5': 'Sexta',
  '6': 'Sábado',
  '7': 'Domingo'
};

interface DaysAndTimeProps {
  allowedDaysAndTimeToReceive: IDayAndTimeToReceive[];
  setAllowedDaysAndTimeToReceive(
    allowedDaysAndTimeToReceive: IDayAndTimeToReceive[]
  ): void;
}

const DaysAndTime: React.FC<DaysAndTimeProps> = ({
  allowedDaysAndTimeToReceive,
  setAllowedDaysAndTimeToReceive
}) => {
  const [defaultStartTime, setDefaultStartTime] = useState<string | undefined>(
    undefined
  );
  const [defaultEndTime, setDefaultEndTime] = useState<string | undefined>(
    undefined
  );

  const setDayAndTimeToReceive = (
    dayAndTimeToReceive: IDayAndTimeToReceive
  ) => {
    const daysAndTimeAux = [...allowedDaysAndTimeToReceive];
    const idxDayAndtimeToReceive = daysAndTimeAux.findIndex(
      (dayAndTime) => dayAndTime.day === dayAndTimeToReceive.day
    );
    daysAndTimeAux[idxDayAndtimeToReceive] = dayAndTimeToReceive;
    setAllowedDaysAndTimeToReceive(daysAndTimeAux);
  };

  const setMultiStartTime = (startTime?: string) => {
    const daysAndTimeAux = [...allowedDaysAndTimeToReceive];
    daysAndTimeAux
      .filter((daysAndTime) => daysAndTime.checked)
      .forEach((daysAndTime) => {
        daysAndTime.startTime = startTime;
      });
    setAllowedDaysAndTimeToReceive(daysAndTimeAux);
  };

  const setMultiEndTime = (endTime?: string) => {
    const daysAndTimeAux = [...allowedDaysAndTimeToReceive];
    daysAndTimeAux
      .filter((daysAndTime) => daysAndTime.checked)
      .forEach((daysAndTime) => {
        daysAndTime.endTime = endTime;
      });
    setAllowedDaysAndTimeToReceive(daysAndTimeAux);
  };

  const applyAllDates = () => {
    const startDate = moment(defaultStartTime);
    const endDate = moment(defaultEndTime);

    if (!endTimeIsGreaterThanStartTime(startDate, endDate)) {
      setMultiStartTime(defaultStartTime);
      setMultiEndTime(defaultEndTime);
    }
  };

  return (
    <Container>
      {allowedDaysAndTimeToReceive.some((dayAndTime) => dayAndTime.checked) && (
        <RangeTimeRow>
          <ContainerCheckboxWeek>
            <Subtitle>{`Aplicar a todos os \n selecionados: `}</Subtitle>
          </ContainerCheckboxWeek>
          <RangeTimePicker
            startTime={defaultStartTime}
            setStartTime={(startTime) => {
              setDefaultStartTime(startTime);
            }}
            endTime={defaultEndTime}
            setEndTime={(endTime) => {
              setDefaultEndTime(endTime);
            }}
          />
          <Button
            name="applyAllButton"
            disabled={
              !defaultStartTime ||
              !defaultEndTime ||
              defaultStartTime > defaultEndTime
            }
            onClick={() => applyAllDates()}
          >
            Aplicar a todos
          </Button>
        </RangeTimeRow>
      )}

      {allowedDaysAndTimeToReceive.map((dayAndTime, idx) => (
        <RangeTimeRow key={idx}>
          <ContainerCheckboxWeek>
            <Checkbox
              name="enableDayCheckbox"
              checked={dayAndTime.checked}
              onChange={(e) => {
                const checked = e.target.checked;
                if (!checked) {
                  setDayAndTimeToReceive({
                    ...dayAndTime,
                    checked,
                    startTime: undefined,
                    endTime: undefined
                  });
                } else {
                  setDayAndTimeToReceive({
                    ...dayAndTime,
                    checked,
                    startTime: defaultStartTime,
                    endTime: defaultEndTime
                  });
                }
              }}
            />
            {WeekDays[dayAndTime.day]}
          </ContainerCheckboxWeek>
          <RangeTimePicker
            key={idx}
            startTime={dayAndTime.startTime}
            endTime={dayAndTime.endTime}
            disabled={!dayAndTime.checked}
            setStartTime={(startTime) => {
              setDayAndTimeToReceive({
                ...dayAndTime,
                startTime
              });
            }}
            setEndTime={(endTime) => {
              setDayAndTimeToReceive({
                ...dayAndTime,
                endTime
              });
            }}
          />
        </RangeTimeRow>
      ))}
    </Container>
  );
};

export default DaysAndTime;
